module.exports = __webpack_public_path__ + "static/media/electron-blue.facc1a48.svg";